<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Minutas Reuniones</h4>
            <div class="small text-muted">Administración de todas las minutas de reuniones</div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col md="9">
          <b-row>
            <b-col md="4">
              <Widget :configWidget="configWidget" reference="cant_reports_last_months" :hasAccess="configWidget.elements.cantReportsLastMonths" />
            </b-col>
            <b-col md="8"></b-col>
          </b-row>
        </b-col>
        <b-col md="3">

          <b-list-group v-show="!isSeller">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openReport()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Minutas de Reuniones</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>
              <p class="mb-1">
                Consulta de todas las minutas de reuniones
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group v-show="isSeller">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openReportSeller()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Mis Minutas de Reuniones</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>
              <p class="mb-1">
                Consulta de todas mis minutas de reuniones
              </p>
            </b-list-group-item>
          </b-list-group>

        </b-col>
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.INFORME_REUNIONES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.INFORME_REUNIONES,
          profile_id: Profiles.PERSONAL,
          elements: {
            cantReportsLastMonths: true,
          }
        },
        primaryColor: '',
      }
    },
    created () {
      Helper.hasAccessView(this.access)

      this.configWidget.elements.cantReportsLastMonths = Helper.hasAccessWidget(this.configWidget, 'cant_reports_last_months')
    },
    mounted() {
      this.setup()
    },
    computed: {
      isSeller() {
        return !!Helper.getSeller()
      }
    },
    methods: {
      setup() {
        if(Session.getSession().settings) {
          this.primaryColor = Session.getSession().settings.color_primary
          this.createCSS()
        }
      },
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"
        document.body.appendChild(hoja)
      },
      openReport() {
        this.$router.push({ name: 'ReportsMeetingsStaffCrudReport' })
      },
      openReportSeller() {
        this.$router.push({ name: 'ReportsMeetingsStaffCrudReportSeller' })
      },
    }
  }
</script>
